import { createSlice } from '@reduxjs/toolkit';

import { CommonState } from '../../types/common';

// State Initialization
const initialState: CommonState = {
    dir: 'ltr',
    lang: 'en'
} as CommonState;

const slice = createSlice({
	name: 'common',
	initialState,
	reducers: {
		SET_DIRECTION: (common, action: any) => {
			common.dir = action.payload;
		},
		SET_LANGUAGE: (common, action) => {
			common.lang = action.payload;
		},
	},
});

export const { SET_DIRECTION, SET_LANGUAGE } = slice.actions;

export default slice.reducer;
